/**
 * Componente de Loading Spinner - Versão Avançada
 * Múltiplas opções de animação e estilos
 */

import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinnerAdvanced = ({
  darkMode = false,
  message = 'Carregando dados...',
  subtitle = 'Buscando informações do banco de dados...',
  size = 'md', // 'sm', 'md', 'lg', 'xl'
  animationType = 'spin', // 'spin', 'pulse', 'bounce', 'float', 'pulse-glow', 'spin-pulse'
  showMessage = true,
  showSubtitle = true,
  fullHeight = true,
  logoPath = '/MaisColorido.svg'
}) => {
  // Tamanhos disponíveis
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32'
  };

  // Animações disponíveis
  const animations = {
    spin: 'animate-spin',
    pulse: 'animate-pulse',
    bounce: 'animate-bounce',
    float: 'animate-float',
    'pulse-glow': 'animate-pulse-glow',
    'spin-pulse': 'animate-spin-pulse'
  };

  return (
    <div className={`${fullHeight ? 'min-h-[400px]' : ''} flex flex-col items-center justify-center ${darkMode ? 'text-slate-300' : 'text-slate-600'
      }`}>
      {/* Container da Logo */}
      <div className="relative flex items-center justify-center mb-2">
        {/* Efeito de fundo circular (opcional) - Nova paleta SIDEB */}
        {animationType !== 'bounce' && (
          <div className={`absolute ${sizes[size]} rounded-full ${darkMode ? 'bg-[#0974BA]/10' : 'bg-[#0974BA]/5'
            } animate-ping`}></div>
        )}

        {/* Logo animada */}
        <img
          src={logoPath}
          alt="Loading"
          className={`${sizes[size]} ${animations[animationType]} drop-shadow-2xl relative z-10`}
          style={{ imageRendering: 'crisp-edges' }}
        />
      </div>

      {/* Mensagem principal */}
      {showMessage && message && (
        <p className="mt-6 text-lg font-semibold animate-pulse">
          {message}
        </p>
      )}

      {/* Subtítulo */}
      {showSubtitle && subtitle && (
        <p className={`mt-2 text-sm ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
          {subtitle}
        </p>
      )}

      {/* Indicador de progresso (dots animados) - Nova paleta SIDEB */}
      <div className="flex gap-1 mt-4">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full ${darkMode ? 'bg-[#0974BA]' : 'bg-[#0974BA]'
              } animate-bounce`}
            style={{
              animationDelay: `${i * 0.15}s`,
              animationDuration: '1s'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoadingSpinnerAdvanced;
